import { FileResponse } from "../apis/monsisra/generated";

export class FileService {
    getFile(file: Blob) {
		return new Promise<void>((resolve) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onloadend = () => {
				// @ts-ignore TODO BDM
				file.contentBase64 = reader.result;
				resolve();
			};
		});
	}

	downloadFile(file: FileResponse){
		const downloadLink = document.createElement("a");
		downloadLink.href = window.URL.createObjectURL(file.data);
		downloadLink.download = file.fileName!;
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
	}
}